<script>
import htmlToImageMixin from "@/mixins/htmlToImageMixin";
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import TypeWriter from "@/components/common/TypeWriter.vue";
import {AiAssistantService} from "@/services/AiAssistantService";

export default {
  name: "AISummary",
  components: {TypeWriter},
  mixins: [htmlToImageMixin],
  data() {
    return {
      aiSummaryText : '',
      canDownloadPdf : false,
      startingTyping : false,
      serverError : ''
    }
  },
  props: {
    htmlElementId : {
      type : String,
      default : 'ai-yearly-table-summary'
    },
    question : {
      type : String,
      default: 'summarize table'
    },
    summarizingText: {
      type : String,
      default : 'Summarizing Accident Incident Data...'
    },
    data : {
      type : Object,
      default : ''
    }
  },
  methods : {
    closeAiSummary() {
      $(`#${this.htmlElementId}_modal`).modal('hide');
    },
    async getAiSummary(aiType) {
      this.aiSummaryText = '';
      this.serverError = '';
      this.canDownloadPdf = false;
      $(`#${this.htmlElementId}_modal`).modal('show');
      await this.summarizeYearlyTable(aiType);
    },
    async summarizeYearlyTable(aiType) {
      let params = new FormData();
      params.append('images[0]', await this.generateBlobImage($(`#${this.htmlElementId}`)[0]));

      params.append('instruction_question', this.question);

      if (aiType !== 'elite_ai') {
        if (aiType === 'open_ai_formatted') {
          params.append('system_prompt', this.systemPrompt);
        }

        const response = await AiAssistantService.getAiSummary(params)
        if (response === false) {
          this.serverError = aiType;
          return;
        }
        this.aiSummaryText = response.output[0].content[0].text;
        return;
      }

      if (this.$route.query?.mode !== 'string') {
        params.append('stream', false);
        // params.append('system_prompt', this.systemPrompt);

        // QWEN2.5 MODELS
        // form.append('model', 'qwen2.5:7b'); // can generate table but wrong contents
        // form.append('model', 'qwen2.5vl'); // wrong outputs in Section 3: Highest Number of Incidents by Category in a Single Year
        // form.append('model', 'qwen2.5vl:7b-q8_0'); // same with qwen2.5vl wrong outputs in Section 3: Highest Number of Incidents by Category in a Single Year
        // form.append('model', 'qwen2.5vl:7b-fp16');  // wrong outputs always repeats text

        // GEMMA3 MODELS
        // form.append('model', 'gemma3'); // good but repeating some rows in highest list
        params.append('model', this.$route.query?.model ?? 'gemma3:12b-it-q8_0'); // currently in 95%


        // form.append('model', 'granite3.2-vision:2b-fp16');
        // params.append('model', 'mistral:7b-instruct-fp16'); // needs to test for image reading


        // LLAVA MODELS
        // form.append('model', 'llava:7b-v1.6-mistral-fp16'); // good but repeating some rows in highest list

        // form.append('model', 'minicpm-v:8b-2.6-fp16'); // can't follow instruction properly, wrong outputs

        // _________________________________________________________________


        params.append('temperature', 1);
        params.append('top_p', 1);
        // ________________________________________________________________

      } else {
        params = {
          messages : [
            {
              role : 'user',
              // content : this.systemPrompt
              content : this.systemPromptCsvAnalyzer
            },
          ],
          model : this.$route.query?.model ?? 'llama3:8b-instruct-fp16',
          // model : 'llama3.2',
          stream : false,
        }
      }
      const response = await AiAssistantService.getEliteAiSummary(params, this.$route.query?.mode)
      if (response === false) {
        this.serverError = aiType;
        return;
      }
      this.aiSummaryText = response.message.content;

    },
    jsonData() {
      return `
  Description,                                   2020, 2021, 2022, 2023, 2024, 2025
  A) COLLISION (INCL. MINOR COLLISION),            4,    3,    4,    3,    0,    0
  B) STRANDING / GROUNDING / TOUCHING BOTTOM,      2,    1,    2,    3,    1,    1
  C) FIRE,                                         1,    1,    0,    3,    2,    2
  D) OIL POLLUSION,                                0,    1,    0,    4,    7,    4
  E) CAPSIZING / FLOODING,                         0,    0,    0,    1,    4,    2
  F) HULL / CONSTRUCTION DAMAGE,                   2,    1,    1,    13,   15,   8
  G) MAIN ENGINE FAILURE,                          29,   50,   33,   52,   47,   46
  H) AUX. MACHINERY FAILURE,                       9,    12,   24,   59,   64,   34
  I) DECK MACHINERY FAILURE,                       12,   31,   29,   87,   97,   68
  J) INJURIES AND SICKNESS,                        9,    11,    5,   8,    38,   10
  K) AFFECTING TO VESSEL OPERATION / BUSINESS,     11,   19,    8,   15,   11,    6
  L) INSPECTION FAILURE,                           2,    0,     1,    9,   10,   2
  M) OTHER SPECIAL CASE,                           0,    3,     9,   44,   44,   15
  SUMMARY,                                         81,   133,  116,  301,  340,  198
      `;
    },
    async downloadAiSummary() {
      let fullContent = $('#full_content').clone();
      fullContent = $(fullContent).removeAttr('style');
      const stringContent = fullContent[0].outerHTML;

      swal.fire({
        'title': `Exporting PDF Summary`,
        'text': "Please wait...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      const printResponse = await AiAssistantService.printAiSummary({
        data : stringContent
      })
      swal.close()
      let url = window.URL.createObjectURL(new Blob([printResponse.data],{type:'application/pdf'}))
      let filename=`${this.htmlElementId}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    }
  },
  computed: {
    renderedContent() {
      if (this.aiSummaryText === '') {
        return '';
      }
      const formatted = this.aiSummaryText.replace(/\\n/g, '\n');
      return DOMPurify.sanitize(marked(formatted));
    },
    systemPrompt() {
      return `
You are a structured data analysis assistant with strong visual understanding of documents and tables.
You are also a **mathematical expert** — you must calculate values precisely using exact numbers only, and never estimate, guess, or round incorrectly.

You will be given an image containing a tabular dataset (such as an incident report by year and category).
Perform the following tasks step-by-step with 100% accuracy:

---

**Title Generation**
    • Analyze the content of the table and generate a dynamic, meaningful title.
    • For example, if the table is about incident reports, use:
        • “Incident Summary Report (YYYY–YYYY)”
    • Adjust the title based on the topic and data range of the table.

---

**Table Extraction**
    • Recreate the full table from the image exactly as it appears.
    • Include **all rows, columns, headers, totals, and summary rows if present**.
    • Preserve structure: every category and every year must be included.
    • Do **not summarize or infer** — this section must be a 1:1 reconstruction of the image.

---

**Total Incidents per Year**
    • Get all incident values in summary category (column-wise).
    • Format the result as a table: \`Year | Total Incidents\`
    • Highlight the year with the **highest total** by marking it with **(Highest)**.
    • Verify that the numbers displays match the data extracted in Section 1.
    • Identify correctly the highest total before putting label beside it.

---

**Highest Number of Incidents by Category in a Single Year**
    • For each category (row), identify the year with its highest incident count.
    • From those, select the **top 6–10 categories** with the highest peak values.
    • Display results in a table: \`Category | Year | Count\`
    • Sort descending by **Count**, and only include one row per category.
    • Mark the highest count overall with **(Highest)**.
    • Ensure no duplicate rows per category and no values are missed.

---

**Category with the Highest 6-Year Average**
You must behave as a mathematical expert in this section.

For each category (row), follow these exact steps:
  1. Add the values for the 6 years (e.g., 2020–2025) to get the **Total**.
  2. Divide that total by **6** to compute the **Average Per Year**.
  3. Use **exact values** from the table extracted in Section 1 (no skipping or assumptions).
  4. Round the average to **1 decimal place only**.
  5. Format the result as a table: \`Category | Total | Average Per Year\`.
  6. Show the numbers used in the total like this:
     \`Deck Machinery Failure | 324 (12+31+29+87+97+68) | 54.0\`
  7. Sort the list by **Average Per Year**, in descending order.
  8. Display only the **top 6 categories**.
  9. Mark the **row with the highest average** using **(Highest)**.
  10. ✅ Most important: **Double-check your calculations**
      • Total must exactly match the values in parenthesis.
      • Total must be accurate and double check if you added the numbers correctly.
      • Average must be accurate and reflect the correct division.
      • If any mismatch occurs, fix it before proceeding.

---

**Key Highlights**
- Write **3–5 concise bullet points** summarizing key insights or trends.
- Mention spikes, consistent top categories, or significant changes across years.

---

**Important Rules**
    • ✅ Use tables whenever presenting structured data.
    • ✅ Never omit, skip, or alter any rows or values.
    • ✅ Avoid estimation — all math must be precise and shown step-by-step.
    • ✅ Do **not include any disclaimers, assumptions, or general commentary**.
    • ✅ Ensure **100% accuracy** in both text and calculations.
      `;
    },
    systemPromptCsvAnalyzer() {
      return `
You are a structured data analysis assistant with expert-level skills in reading tabular datasets written in CSV format as plain text.
You are also a mathematical expert — your calculations must be 100% precise, based only on the numbers provided. Do not estimate, guess, or round incorrectly.

You will be given a CSV-formatted dataset (e.g., an incident report by year and category).
Perform the following tasks step-by-step with absolute accuracy:

1. Title Generation
Analyze the dataset and generate a dynamic, meaningful title based on its topic and date range.

Example:

“Incident Summary Report (2020–2025)”

Make sure the title adjusts based on the dataset's actual subject and timespan.

2. Section 1: Table Preview
Recreate and display the entire CSV-formatted table exactly as provided.

Include:

All headers (columns),

All data rows (including totals if present).

Do not infer, summarize, or modify the original data.

This section is a faithful representation of the input.

3. Section 2: Total Incidents per Year
For each year (each column excluding the first column), calculate the total number of incidents across all categories.

Format results as a table:
Year | Total Incidents

Highlight the year with the highest total using (Highest).

Ensure all sums are based on only the numbers shown in Section 1, with no assumptions.

4. Section 3: Highest Number of Incidents by Category in a Single Year
For every category (row), identify the year with the highest incident count.

From these results, select the top 6–10 categories based on that highest value.

Format results in a table:
Category | Year | Count

Include only one row per category — the peak year.

Sort by Count in descending order.

Mark the overall highest count with (Highest).

✅ Do not repeat categories, and ensure all values are verified.

5. Section 4: Category with the Highest 6-Year Average
You must behave as a math expert in this section.

Steps:

For each category (row), add up all 6 years of data.

Compute the average per year = total ÷ 6.

Format the result as:
Category | Total | Average Per Year

Include a breakdown of values like:
Deck Machinery Failure | 324 (12+31+29+87+97+68) | 54.0

Round only the average to 1 decimal place.

Sort results by Average Per Year in descending order.

Display only the top 6 categories.

Mark the highest average with (Highest).

✅ Double-check:

All added totals match the values in parentheses.

All averages are correct and based on those exact totals.

6. Section 5: Key Highlights
Write 3–5 concise bullet points identifying key trends or takeaways:

Highest incident years,

Most consistent categories,

Notable spikes or drops,

Any dominant patterns or unusual observations.

✅ Important Execution Rules
Use tables wherever needed for clarity.

Do not include disclaimers, explanations, or commentary.

Do not skip or alter any data.

All math must be exact and verifiable.

Your response must be clear, structured, and 100% accurate in both content and calculations.





This is the CSV data:

  Description,                                   2020, 2021, 2022, 2023, 2024, 2025
  A) COLLISION (INCL. MINOR COLLISION),            4,    3,    4,    3,    0,    0
  B) STRANDING / GROUNDING / TOUCHING BOTTOM,      2,    1,    2,    3,    1,    1
  C) FIRE,                                         1,    1,    0,    3,    2,    2
  D) OIL POLLUSION,                                0,    1,    0,    4,    7,    4
  E) CAPSIZING / FLOODING,                         0,    0,    0,    1,    4,    2
  F) HULL / CONSTRUCTION DAMAGE,                   2,    1,    1,    13,   15,   8
  G) MAIN ENGINE FAILURE,                          29,   50,   33,   52,   47,   46
  H) AUX. MACHINERY FAILURE,                       9,    12,   24,   59,   64,   34
  I) DECK MACHINERY FAILURE,                       12,   31,   29,   87,   97,   68
  J) INJURIES AND SICKNESS,                        9,    11,    5,   8,    38,   10
  K) AFFECTING TO VESSEL OPERATION / BUSINESS,     11,   19,    8,   15,   11,    6
  L) INSPECTION FAILURE,                           2,    0,     1,    9,   10,   2
  M) OTHER SPECIAL CASE,                           0,    3,     9,   44,   44,   15
  SUMMARY,                                         81,   133,  116,  301,  340,  198
      `
    }
  }
}
</script>

<template>
  <div>
<!--    <button class="ai-btn kirbi-button mr-1 mb-1 pl-2 pr-2" id="ai-btn" @click="getAiSummary('open_ai')">-->
<!--      <img style="height: 30px; width: 30px" :src="$route.query.i ? require(`@/assets/ai-icons/${$route.query.i}.png`) : require(`@/assets/ai-icons/kirbi.svg`)" alt="AI Icon">-->
<!--      <span class="ai-summary-text">AI Summary</span>-->
<!--      <span class="icon">-->
<!--        </span>-->
<!--    </button>-->

    <button class="ai-btn kirbi-button mr-1 mb-1 pl-2 pr-2" id="ai-btn" @click="getAiSummary('elite_ai')">
      <img style="height: 30px; width: 30px" :src="$route.query.i ? require(`@/assets/ai-icons/${$route.query.i}.png`) : require(`@/assets/ai-icons/kirbi.svg`)" alt="AI Icon">
      <span class="ai-summary-text">AI Summary</span>
      <span class="icon">
    </span>
    </button>


<!--    <button class="ai-btn ai-teal mr-1" id="ai-btn" @click="getAiSummary('open_ai_formatted')">-->
<!--      <span class="ai-summary-text">AI SUMMARY 2</span>-->
<!--      <span class="icon">-->
<!--      <img style="height: 20px; width: 20px" :src="$route.query.i ? require(`@/assets/ai-icons/${$route.query.i}.png`) : require(`@/assets/ai-icons/1.png`)" alt="AI Icon">-->
<!--    </span>-->

<!--    </button>-->

<!--    <button class="ai-btn" id="ai-btn" @click="getAiSummary('elite_ai')">-->
<!--      <span class="ai-summary-text">AI SUMMARY 3</span>-->
<!--    <span class="icon">-->
<!--      <img style="height: 20px; width: 20px" :src="$route.query.i ? require(`@/assets/ai-icons/${$route.query.i}.png`) : require(`@/assets/ai-icons/1.png`)" alt="AI Icon">-->
<!--    </span>-->

<!--    </button>-->

    <div class="modal fade" data-backdrop="static" data-keyboard="false" :id="`${htmlElementId}_modal`" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <form class="modal-content">
          <div class="modal-body" style="max-height: 70vh; overflow-y: auto" id = "full_content">
            <div>
              <div v-if="aiSummaryText === ''" class="text-center">
                <span v-if="serverError !== ''">
                  {{ 'There\s an error from the server' }}

                   <button class="ml-1" @click="getAiSummary(serverError)" style="
    padding: 5px 8px;
    border-radius: 8px;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    cursor: pointer;
  ">
    🔄 Try again
  </button>
                </span>
                <i v-else class="loading-text">
                  {{ summarizingText }}
                </i>
              </div>
              <div v-else class="ai-answer text-left">
                <TypeWriter
                  :html-content="renderedContent"
                  @doneWriting="canDownloadPdf = true"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row w-100">
              <div class="col-6 w-50">
                <button
                  v-if="canDownloadPdf"
                  :class="canDownloadPdf === false ? 'e-btn-blue-gray-disabled' : ''"
                  class="e-btn-primary btn btn-dark btn-sm force-white-all float-left" @click.prevent="downloadAiSummary"><font-awesome-icon icon="download" class="mr-2"></font-awesome-icon>DOWNLOAD PDF</button>
              </div>
              <div class="col-6 col-md-auto w-50">
                <button :disabled="canDownloadPdf === false && serverError === ''" type="button" class="btn btn-sm btn-secondary float-right" @click="closeAiSummary">Close</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ai-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.4rem;
  font-weight: bold;
  font-size: 0.95rem;
  color: white !important;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: transform 0.8s ease, box-shadow 0.3s ease;
  width: 152px;
  height: 42px;
}

.ai-btn.ai-purple {
  background: linear-gradient(135deg, #6a0dad, #b19cd9);
  box-shadow: 0 0 10px rgba(138, 43, 226, 0.4);
}

.ai-btn.ai-purple:hover {
  box-shadow: 0 0 15px rgba(138, 43, 226, 0.6);
}

.ai-btn.ai-teal {
  background: linear-gradient(135deg, #008080, #66cccc);
  box-shadow: 0 0 10px rgba(0, 128, 128, 0.4);
}

.ai-btn.ai-teal:hover {
  box-shadow: 0 0 15px rgba(0, 128, 128, 0.6);
}

.ai-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 0 15px rgba(255, 0, 0, 0.6);
}

.ai-btn::after {
  content: '';
  position: absolute;
  top: -20%;
  left: -20%;
  width: 140%;
  height: 140%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 10%, transparent 70%);
  animation: pulse 2s infinite;
  pointer-events: none;
  z-index: 0;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.6;
  }
  70% {
    transform: scale(1.2);
    opacity: 0;
  }
  100% {
    transform: scale(0.9);
    opacity: 0;
  }
}

.icon {
  display: flex;
  align-items: center;
}

.ai-summary-text {
  color: white;
  font-size: 15px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
  Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}

.kirbi-button {
  background-color: #ED1C24;
}
</style>
